import { FC, HTMLAttributes, ReactNode } from "react";
import Image from "next/image";
import HtmlText from "@/sections/common/HtmlText";
import TButton from "../atoms/buttons/TButton";
import clsx from "clsx";
import { ITextButton } from "../atoms/buttons/types";

// ------------------------------------------------------------------------------------------

export type IUseCasesCard = {
  heading?: string;
  description?: ReactNode;
  image?: { src: string; alt: string };
  button?: ITextButton;
  variant?: "secondary" | "white" | "light_primary";
};

export type IUseCasesCardProps = HTMLAttributes<HTMLDivElement> &
  IUseCasesCard & {};

const UseCasesCard: FC<IUseCasesCardProps> = (props) => {
  const { heading, description, image, button, className, ...other } = props;

  return (
    <div
      className={clsx(
        "group h-full bg-white transition-all duration-[600ms] ease-out hover:bg-primary-900",
        className,
      )}
      {...other}
    >
      <div className="h-[210px] w-auto lg:h-[180px] xl:h-[228px]">
        {image && (
          <Image
            src={image.src}
            alt={image.alt}
            className="!h-full w-full object-cover"
            width={379}
            height={228}
          />
        )}
      </div>

      <div className="p-4 md:min-h-[188px] md:px-5 md:py-6 lg:min-h-[202px]">
        <div className="relative">
          {heading && (
            <h2 className="mb-4 line-clamp-2 text-lg font-medium text-black-900 transition-all duration-[600ms] ease-out group-hover:text-white lg:mb-6 lg:text-h6 xl:text-h5">
              {heading}
            </h2>
          )}
          {button && (
            <TButton
              id={button.id}
              className="bottom-0 opacity-0 transition-opacity duration-[600ms] ease-out group-hover:opacity-100"
              variant={button.variant}
              href={button.link}
              target={button.target}
              radius={button.radius}
            >
              {button.text}
            </TButton>
          )}
        </div>
        {description && (
          <HtmlText className="-mt-11 line-clamp-3 group-hover:prose-p:text-opacity-0 group-hover:prose-p:transition-opacity group-hover:prose-p:group-hover:prose-p:duration-[600ms] group-hover:prose-p:ease-out">
            {description}
          </HtmlText>
        )}
      </div>
    </div>
  );
};

export default UseCasesCard;
